import autobind from 'autobind-decorator';
import { extendObservable, computed } from 'mobx';

@autobind
class SoccerMatchTeamStatModel {
  location;

  constructor(data, location) {
    extendObservable(this, data);

    this.location = location;
  }

  @computed
  get chart() {
    const {
      pointsAverage,
      pointsLossAverage,
      fieldGoalsPercentage,
      threePointFieldGoalsPercentage,
      freeThrowsPercentage,
      assistsAverage,
      reboundsTotalAverage,
      stealsAverage,
      blockedShotsAverage,
      turnoversAverage
    } = this;

    let result = {
      pointsAverage: { p: 0, v: '' },
      pointsLossAverage: { p: 0, v: '' },
      fieldGoalsPercentage: { p: 0, v: '' },
      threePointFieldGoalsPercentage: { p: 0, v: '' },
      freeThrowsPercentage: { p: 0, v: '' },
      assistsAverage: { p: 0, v: '' },
      reboundsTotalAverage: { p: 0, v: '' },
      stealsAverage: { p: 0, v: '' },
      blockedShotsAverage: { p: 0, v: '' },
      turnoversAverage: { p: 0, v: '' }
    };

    // assistsAverage: "20.7"
    // blockedShotsAverage: "1.7"
    // fieldGoalsPercentage: "47.1"
    // firstFive: 4
    // firstFreeThrow: 4
    // firstPoint: 5
    // firstSeven: 4
    // firstTen: 2
    // firstThreePoint: 4
    // freeThrowsMadeAverage: "21.7"
    // freeThrowsPercentage: "82.3"
    // id: 203
    // imgPath: "/sports/basketball/team/203.png"
    // name: "댈러스"
    // pointsAverage: "113.7"
    // pointsLossAverage: "105.7"
    // reboundsTotalAverage: "40.0"
    // shortName: "dal"
    // stealsAverage: "9.7"
    // threePointFieldGoalsPercentage: "32.7"
    // turnoversAverage: "9.7"
    // winPercentage: "33.3"

    // 득점, 실점 - 150을 기준으로 150이상시 100% 고정 득점은 높은 팀이 빨간색, 실점은 낮은팀이 빨간색
    // 야투, 3점슛, 자유투 - 100%를 기준으로 높은 팀이 빨간색
    // 어시스트 - 30을 기준으로 30이상일 경우 100% 고정 높은게 빨간색
    // 리바운드 50을 기준으로 50이상일 경우 100% 고정 높은게 빨간색
    // 스틸, 블록 - 10을 기준으로 10이상일 경우 100% 고정 높은게 빨간색
    // 턴오버 - 30을 기준으로 30이상일 경우 100% 고정 낮은숫자가 빨간색

    // 득점
    if (!!pointsAverage) {
      const value = +((pointsAverage / 150) * 100).toFixed(1);

      result.pointsAverage = {
        p: value > 100 ? 100 : value,
        v: pointsAverage
      };
    }

    // 실점
    if (!!pointsLossAverage) {
      const value = +((pointsLossAverage / 150) * 100).toFixed(1);

      result.pointsLossAverage = {
        p: value > 100 ? 100 : value,
        v: pointsLossAverage
      };
    }

    // 야투
    if (!!fieldGoalsPercentage) {
      result.fieldGoalsPercentage = {
        p: fieldGoalsPercentage > 100 ? 100 : fieldGoalsPercentage,
        v: `${Math.floor(+fieldGoalsPercentage)}%`
      };
    }

    // 3점슛
    if (!!threePointFieldGoalsPercentage) {
      result.threePointFieldGoalsPercentage = {
        p:
          threePointFieldGoalsPercentage > 100
            ? 100
            : threePointFieldGoalsPercentage,
        v: `${Math.floor(threePointFieldGoalsPercentage)}%`
      };
    }

    // 자유투
    if (!!freeThrowsPercentage) {
      result.freeThrowsPercentage = {
        p: freeThrowsPercentage > 100 ? 100 : freeThrowsPercentage,
        v: `${Math.floor(+freeThrowsPercentage)}%`
      };
    }

    //  어시스트
    if (!!assistsAverage) {
      const value = +((assistsAverage / 30) * 100).toFixed(1);

      result.assistsAverage = {
        p: value > 100 ? 100 : value,
        v: assistsAverage
      };
    }

    //  리바운드
    if (!!reboundsTotalAverage) {
      const value = +((reboundsTotalAverage / 50) * 100).toFixed(1);

      result.reboundsTotalAverage = {
        p: value > 100 ? 100 : value,
        v: reboundsTotalAverage
      };
    }

    //  스틸
    if (!!stealsAverage) {
      const value = +((stealsAverage / 10) * 100).toFixed(1);

      result.stealsAverage = {
        p: value > 100 ? 100 : value,
        v: stealsAverage
      };
    }

    //  블록
    if (!!blockedShotsAverage) {
      const value = +((blockedShotsAverage / 10) * 100).toFixed(1);

      result.blockedShotsAverage = {
        p: value > 100 ? 100 : value,
        v: blockedShotsAverage
      };
    }

    //  턴오버
    if (!!turnoversAverage) {
      const value = +((turnoversAverage / 30) * 100).toFixed(1);

      result.turnoversAverage = {
        p: value > 100 ? 100 : value,
        v: turnoversAverage
      };
    }

    return result;
  }

  @computed
  get player() {
    let result = {
      name: '미정',
      visible: false
    };

    return result;
  }

  @computed
  get stat() {
    const { seasonStat, vsStat } = this;

    if (!!seasonStat && !!vsStat) {
      return {
        season: `${seasonStat.win}승 ${seasonStat.lose}패`,
        vs: `${vsStat.win}승 ${vsStat.lose}패`
      };
    } else {
      return {
        season: '',
        vs: ''
      };
    }
  }
}

export default SoccerMatchTeamStatModel;
